<ng-container *ngIf="countries && languages">
  <div
    class="login-form-wrapper"
    [style.display]="hasRequested === 'true' ? 'none' : 'block'"
    [ngClass]="{ 'asm-enabled': asmEnabled }"
  >
    <cx-global-message class="login-global-message">
      <div class="global-message-wrapper"></div>
    </cx-global-message>
    <div class="login-form-content">
      <div class="login-error alert alert-danger alert-dismissible fade show" role="alert" *ngIf="err">
        {{ 'login.error' | cxTranslate }}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="signinForm" (ngSubmit)="login()">
        <div class="form-group login-form-country login-form-businesstype" *ngIf="!asmEnabled">
          <div
            *ngIf="businnesTypes.length > 1"
            ngbDropdown
            class="country-selection-container mat-primary mat-form-field"
            [placement]="['bottom', 'top']"
            (openChange)="onOpenDropdown($event)"
          >
            <span class="country-label">{{ 'login.accountType' | cxTranslate }}</span>
            <button
              class="btn-link country-selection-dropdown"
              id="businessTypeSelectorDropdown"
              ngbDropdownToggle
              type="button"
              disableOptionCentering
            >
              <span class="country-selected">{{ getBusineessTypeActiveLabel() }}</span>
              <mat-icon class="material-icons-sharp select-button" [class.rotated]="dropdownIsOpened"
                >expand_more</mat-icon
              >
              <div
                ngbDropdownMenu
                [ngClass]="selectedCountry"
                class="dropdown-menu"
                aria-labelledby="businessTypeSelectorDropdown"
              >
                <button
                  ngbDropdownItem
                  [class.selected]="item.code === businessTypeSelected"
                  (click)="selectBusinessType(item)"
                  *ngFor="let item of businnesTypes; let countryIndex = index"
                  type="button"
                >
                  <mat-icon
                    svgIcon="check"
                    [ngClass]="activeBusinessType$ | async"
                    class="selected-icon"
                    *ngIf="item.code === businessTypeSelected"
                  ></mat-icon>
                  {{ item.label }}
                </button>
              </div>
            </button>
          </div>
        </div>
        <div
          class="form-group login-form-country"
          *ngIf="!asmEnabled"
          [class.no-flags]="!(isCountryFlagIconEnabled$ | async)"
        >
          <div
            ngbDropdown
            class="country-selection-container mat-primary mat-form-field"
            [placement]="['bottom', 'top']"
            (openChange)="countryOnOpenDropdown($event)"
          >
            <span class="country-label">{{ 'login.selectCountry' | cxTranslate }}</span>
            <button
              class="btn-link country-selection-dropdown"
              id="dealerSelectorDropdown"
              ngbDropdownToggle
              (click)="onCountrySelection(countries)"
              type="button"
              disableOptionCentering
              [ngClass]="[activeCountry$ | async, !(isCountryFlagIconEnabled$ | async) ? 'no-flags' : '']"
            >
              <span matPrefix [class.flag-prefix]="countrySelected" *ngIf="isCountryFlagIconEnabled$ | async">
                <mat-icon matprefix="" class="material-icons-sharp light" *ngIf="!countrySelected">language</mat-icon>
                <span *ngIf="countrySelected" class="flag:{{ countrySelected }}"></span>
              </span>
              <span class="country-selected">{{ selectedCountry }}</span>
              <mat-icon
                class="material-icons-sharp select-button"
                [class.rotated]="countryDropdownIsOpened"
                *ngIf="currentCountry !== 'cn'; else selectArrow"
                >expand_more</mat-icon
              >
              <ng-template #selectArrow>
                <mat-icon [ngClass]="activeCountry$ | async" class="mat-select-arrow select-button"></mat-icon>
              </ng-template>
              <div
                ngbDropdownMenu
                [ngClass]="selectedCountry"
                class="dropdown-menu"
                aria-labelledby="dealerSelectorDropdown"
              >
                <button
                  ngbDropdownItem
                  [class.selected]="item.isocode === countrySelected"
                  (click)="selectCountry(item)"
                  *ngFor="let item of countries; let countryIndex = index"
                  type="button"
                >
                  <mat-icon
                    svgIcon="check"
                    [ngClass]="activeCountry$ | async"
                    class="selected-icon"
                    *ngIf="item.isocode === countrySelected"
                  ></mat-icon>
                  <span class="flag:{{ item.isocode }}" *ngIf="isCountryFlagIconEnabled$ | async"></span>
                  {{ item.name }}
                </button>
              </div>
            </button>
          </div>
        </div>
        <div class="form-group login-form-language" *ngIf="!asmEnabled">
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <mat-label>{{ 'login.selectLanguage' | cxTranslate }}</mat-label>
            <mat-select
              formControlName="language"
              [(ngModel)]="langSelected"
              (selectionChange)="selectLang($event)"
              disableOptionCentering
              [ngClass]="activeLanguage$ | async"
              [panelClass]="['login-select', activeCountry$ | async, !requestAccountEnabled ? 'no-register' : '']"
            >
              <ng-container *ngFor="let item of language; let langIndex = index">
                <mat-option class="js-login-selectLanguange" [id]="langIndex" value="{{ item.isocode }}">{{
                  item.name
                }}</mat-option>
              </ng-container>
            </mat-select>
            <span matPrefix>
              <mat-icon matprefix="" class="material-icons-sharp light">translate</mat-icon>
            </span>
          </mat-form-field>
        </div>
        <div class="form-group login-form-email" [class.autofilled]="autofilled">
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <mat-label>{{ 'login.emailAdd' | cxTranslate }}</mat-label>
            <input
              matInput
              type="email"
              id="login-form-email"
              class="form-control"
              formControlName="email"
              [placeholder]="
                isEmailFocused ? checkRememberMe(signinForm.controls.email.value, 'login.emailAdd' | cxTranslate) : ''
              "
              (focus)="isEmailFocused = true; onFocus('email')"
              (blur)="isEmailFocused = false"
              #emailAddr
            />
          </mat-form-field>
        </div>
        <div class="form-group login-form-password" [class.login-form-asm-password]="asmEnabled">
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <mat-label>{{ 'login.password' | cxTranslate }}</mat-label>
            <input
              matInput
              [type]="hidePassword ? 'password' : 'text'"
              id="login-form-password"
              class="form-control"
              formControlName="password"
              [placeholder]="
                isPasswordFocused
                  ? checkRememberMe(signinForm.controls.password.value, 'login.password' | cxTranslate)
                  : ''
              "
              (focus)="isPasswordFocused = true; onFocus('password')"
              (blur)="isPasswordFocused = false"
              #passwordField
            />
            <span matSuffix>
              <mat-icon matSuffix="" class="material-icons-outlined" (click)="hidePassword = !hidePassword">{{
                hidePassword ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </span>
          </mat-form-field>
        </div>
        <div class="form-forgot-mobile">
          <a (click)="goToForgotPassword()" [routerLink]="['/login/forgot-password']">{{
            'login.forgotPassword' | cxTranslate
          }}</a>
        </div>
        <div class="form-group login-form-button">
          <button mat-button class="btn-primary">{{ 'login.login' | cxTranslate }}</button>
        </div>
        <div class="d-flex" [ngClass]="isCountrySnah() ? 'justify-content-end' : 'justify-content-between'">
          <mat-checkbox
            [class.d-none]="isCountrySnah()"
            class="form-show-srp js-login-srpCheckbox"
            [disableRipple]="true"
            formControlName="showSrpToggle"
          >
            {{ 'login.showSrp' | cxTranslate }}
          </mat-checkbox>
          <div class="form-forgot d-none d-md-block">
            <a (click)="goToForgotPassword()" [routerLink]="['/login/forgot-password']">{{
              'login.forgotPassword' | cxTranslate
            }}</a>
          </div>
        </div>
      </form>

      <div class="form-request" *ngIf="!asmEnabled && requestAccountEnabled">
        <p>
          {{ 'login.noAccount' | cxTranslate }}
          <a
            class="routerLink"
            *ngIf="requestAccountUrl"
            href="{{ requestAccountUrl }}"
            target="_blank"
            (click)="requestAccount(true, requestAccountUrl)"
            >{{ 'login.requestAccount' | cxTranslate }}</a
          >

          <a
            [routerLink]="['/login']"
            *ngIf="requestAccountUrl === ''"
            (click)="requestAccount(true, requestAccountUrl)"
            >{{ 'login.requestAccount' | cxTranslate }}</a
          >
        </p>
      </div>

      <div class="form-filler" *ngIf="!!asmEnabled"></div>
    </div>
  </div>
</ng-container>
